import {useConsumerUser} from "~/contexts";

export const useQuestionnaireVariant = (): boolean => {
  const {userContext} = useConsumerUser();

  return userContext?.questionnaire_eligible ?? false;
};
